import type { ReactNode } from 'react';
import { BellIcon, MailIcon, SearchIcon, ShieldIcon, StepsIcon } from '../icons';
import { PhoneMockup } from './PhoneMockup';
import { Glow, SectionHeader } from './primitives';

interface Benefit {
  icon: ReactNode;
  title: string;
  body: string;
}

const BENEFITS: Benefit[] = [
  {
    icon: <SearchIcon className="h-6 w-6" />,
    title: 'Разбираем вашу ситуацию',
    body: 'Изучаем документы и находим детали, которые легко упустить самостоятельно.',
  },
  {
    icon: <StepsIcon className="h-6 w-6" />,
    title: 'Даём пошаговый план',
    body: 'Объясняем, что делать и в каком порядке — без юридического тумана и лишних терминов.',
  },
  {
    icon: <ShieldIcon className="h-6 w-6" />,
    title: 'Защищаем ваши права',
    body: 'Готовим заявления и жалобы, сопровождаем на каждом этапе взаимодействия.',
  },
  {
    icon: <BellIcon className="h-6 w-6" />,
    title: 'Держим в курсе',
    body: 'Напоминаем о сроках и присылаем уведомления о статусе вашего обращения.',
  },
];

export function BenefitsSection() {
  return (
    <section className="relative overflow-hidden px-4 py-14 md:px-8 md:py-20 xl:px-20">
      <Glow color="blue" size={520} opacity={0.2} blur={70} className="right-0 top-16 hidden lg:block" />

      <div className="relative mx-auto grid max-w-[1280px] items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div className="flex flex-col gap-8">
          <SectionHeader
            eyebrow="Что вы получаете"
            title="Понятная помощь вместо юридического тумана"
          />
          <ul className="flex flex-col gap-6 md:gap-7">
            {BENEFITS.map((benefit) => (
              <li key={benefit.title} className="flex items-start gap-4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-soft-gradient text-accent">
                  {benefit.icon}
                </span>
                <div className="flex flex-col gap-1">
                  <span className="text-[17px] font-semibold text-ink md:text-[19px]">
                    {benefit.title}
                  </span>
                  <p className="text-[15px] leading-[1.5] text-muted md:text-base">{benefit.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex flex-col items-center gap-6 rounded-4xl border border-white/90 bg-soft-gradient p-6 md:p-9">
          <div className="flex flex-col items-center gap-2 text-center">
            <span className="rounded-lg bg-white px-2.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.08em] text-accent">
              Telegram-бот
            </span>
            <h3 className="text-[20px] font-semibold tracking-[-0.006em] text-ink md:text-[22px]">
              Консультация в удобном мессенджере
            </h3>
          </div>

          <PhoneMockup />

          <div className="flex w-full max-w-[340px] flex-col gap-1.5 rounded-2xl border border-line bg-white/90 p-4">
            <div className="flex items-center gap-2 text-[13px] font-semibold text-accent">
              <MailIcon className="h-5 w-5" />
              Или письмом на почту
            </div>
            <span className="text-[15px] font-semibold text-ink">Ваш ответ готов</span>
            <span className="text-[13px] text-muted">
              Отправим разбор ситуации и план действий на email.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
